import type { ValorBrowserTokenizationSession } from '@pillar-portal/api-types/ipg/valor/payment';

export type ValorCardTokenizationRequestInput = {
    delegateToken: ValorBrowserTokenizationSession;
    normalizedPan: string;
    normalizedExpiryDate: string;
};

export const buildValorCardTokenizationRequest = (input: ValorCardTokenizationRequestInput) =>
    ({
        epi: input.delegateToken.epi,
        txn_type: 'cardToken',
        client_token: input.delegateToken.client_token,
        pan: input.normalizedPan,
        expirydate: input.normalizedExpiryDate,
        cctoken: '',
    }) satisfies Record<string, string>;
